var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionsConfig,
          "left-side-class": "col-xl-5",
          page: _vm.pageConfig,
          "right-side-class":
            "col-xl-7 align-items-end d-flex pb-3 justify-content-end"
        }
      }),
      _c("filter-manager", {
        ref: "filterComponent",
        staticClass: "mb-4",
        attrs: { filters: _vm.filtersConfig },
        on: {
          search: function($event) {
            return _vm.onSearchHandler()
          }
        },
        model: {
          value: _vm.selectedFilters,
          callback: function($$v) {
            _vm.selectedFilters = $$v
          },
          expression: "selectedFilters"
        }
      }),
      _c("separator", {
        staticClass: "my-3",
        attrs: { text: "Resultado de Dispensas" }
      }),
      _c("search-result", {
        attrs: {
          "educative-regions": _vm.educativeRegions,
          result: _vm.result
        },
        on: { "on-refresh-result": _vm.onRefreshResult }
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": true },
            on: { "pagination-go-page": _vm.goToPage }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }